import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";

// ✅ FIXED: use react-helmet-async (not react-helmet)
import { Helmet, HelmetProvider } from "react-helmet-async";

import B7TowerMarketing from "./pages/B7MarketingTower";
import AgentProfile from "./pages/AgentProfile";
import Profile from "./pages/Profile";
import NotFound404 from "./pages/NotFound404";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Listings from "./pages/Listings";
import ListingsForSale from "./pages/ListingsForSale";
import ListingsForRent from "./pages/ListingsForRent";
import Contact from "./pages/Contact";
import CreateListing from "./pages/CreateListing";
import EditListing from "./pages/EditListing";
import ListingDetails from "./pages/ListingDetails";
import PrivateRoute from "./components/PrivateRoute";
import Header from "./components/navbar/Header";
import Footer from "./components/Footer";
import SellerProfile from "./pages/SellerProfile";
import SeeAllFeaturedSellers from "./pages/SeeAllFeaturedSellers";
import SeeAllFeaturedProperties from "./pages/SeeAllFeaturedProperties";
import SeeAllFeaturedBikes from "./pages/SeeAllFeaturedBikes";
import BuyerRequestsFeed from "./pages/Feed";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BargainsListings from "./pages/BargainsListings";
import BuildingMaterials from "./pages/BuildingMaterials";
import ProjectsPage from "./pages/Projects";
import { LoadingProvider } from "./contexts/loading/LoadingContext";
import { UserProvider } from "./contexts/user/UserContext";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";
import RoyalJewelPremium from "./pages/RoyalJewel";
import DohaHeightsLandingPage from "./pages/DohaHeights";
import FloriaHeightsPage from "./pages/FloriaHeights";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import RecommendationPopup from "./components/recommendationPopup/RecommendationPopup";
import TermsOfService from "./pages/TermsOfServices";
import DeenVillasLanding from "./pages/DeenAssociates";
import UrbanComplexLanding from "./pages/UrbanComplex";
import RegisterAgency from "./pages/RegisterAgency";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { db } from "./firebase.config";
import AddPropertyToAgent from "./pages/AddPropertyToAgent";
import ValenciaHeights from "./pages/ValenciaHeights";
import J7Emporium from "./pages/J7Emporium";
import RSMall from "./pages/RSMall";
import IslamabadHeights from "./pages/IslamabadHeights";
import BurjQuaidLanding from "./pages/BurjQuaid";
import Tower4 from "./pages/Tower4";
import SukoonVista from "./pages/SukoonVista";
import HMRWaterfrontPage from "./pages/HMRWaterFront";
import Citadel7 from "./pages/Citadel7";

/* =========================================================
   SITE CONSTANTS
   ========================================================= */
const SITE_URL = "https://www.estateghar.com"; // ⚠️ change to your real domain
const SITE_NAME = "EstateGhar";

/* =========================================================
   ROUTES
   ========================================================= */
const ROUTES = {
  Home: { id: "1", element: Home, path: "/" },
  SignIn: { id: "2", element: SignIn, path: "/sign-in" },
  SignUp: { id: "3", element: SignUp, path: "/sign-up" },
  SellerProfile: {
    id: "4",
    element: SellerProfile,
    path: "/seller-profile/:sellerId",
  },
  ForgotPassword: {
    id: "5",
    element: ForgotPassword,
    path: "/forgot-password",
  },
  Listings: { id: "6", element: Listings, path: "/category/:categoryName" },
  CreateListing: { id: "7", element: CreateListing, path: "/create-listing" },
  EditListing: {
    id: "8",
    element: EditListing,
    path: "/edit-listing/:listingId",
  },
  ListingDetails: {
    id: "9",
    element: ListingDetails,
    path: "/category/:categoryName/:listingId",
  },
  SeeAllFeaturedSellers: {
    id: "10",
    element: SeeAllFeaturedSellers,
    path: "/featured-agents",
  },
  SeeAllFeaturedProperties: {
    id: "11",
    element: SeeAllFeaturedProperties,
    path: "/featured-properties",
  },
  SeeAllFeaturedBikes: {
    id: "12",
    element: SeeAllFeaturedBikes,
    path: "/featured-bikes",
  },
  BuyerRequestsFeed: {
    id: "13",
    element: BuyerRequestsFeed,
    path: "/feed",
  },
  PrivacyPolicy: {
    id: "14",
    element: PrivacyPolicy,
    path: "/privacy-policy",
  },
  BargainsListings: {
    id: "15",
    element: BargainsListings,
    path: "/bargains-listings",
  },
  BuildingMaterials: {
    id: "16",
    element: BuildingMaterials,
    path: "/building-materials",
  },
  Projects: { id: "17", element: ProjectsPage, path: "/projects" },
  RoyalJewelPremium: {
    id: "18",
    element: RoyalJewelPremium,
    path: "/projects/royal-jewel",
  },
  DohaHeightsLandingPage: {
    id: "19",
    element: DohaHeightsLandingPage,
    path: "/projects/doha-heights",
  },
  FloriaHeightsPage: {
    id: "20",
    element: FloriaHeightsPage,
    path: "/projects/floria-heights",
  },
  Blogs: { id: "21", element: Blogs, path: "/blogs" },
  BlogPost: { id: "22", element: BlogPost, path: "/blog/:slug" },
  TermsOfService: { id: "23", element: TermsOfService, path: "/terms" },
  DeenVillasLanding: {
    id: "24",
    element: DeenVillasLanding,
    path: "/projects/deen-villas",
  },
  UrbanComplexLanding: {
    id: "25",
    element: UrbanComplexLanding,
    path: "/projects/urban-complex",
  },
  RegisterAgency: {
    id: "26",
    element: RegisterAgency,
    path: "/register-agency",
  },
  AgentProfile: {
    id: "27",
    element: AgentProfile,
    path: "/agent-profile/:agentId",
  },
  AddPropertyToAgent: {
    id: "28",
    element: AddPropertyToAgent,
    path: "/add-property-to-agent/:agentId",
  },
  B7TowerMarketing: {
    id: "29",
    element: B7TowerMarketing,
    path: "/projects/b7-tower-1",
  },
  ValenciaHeights: {
    id: "30",
    element: ValenciaHeights,
    path: "/projects/valencia-heights",
  },
  J7Emporium: {
    id: "31",
    element: J7Emporium,
    path: "/projects/j7-emporium",
  },
  RSMall: {
    id: "32",
    element: RSMall,
    path: "/projects/rs-mall",
  },
  IslamabadHeights: {
    id: "33",
    element: IslamabadHeights,
    path: "/projects/islamabad-heights",
  },
  BurjQuaid: {
    id: "34",
    element: BurjQuaidLanding,
    path: "/projects/burj-quaid",
  },
  Tower4: {
    id: "35",
    element: Tower4,
    path: "/projects/tower4",
  },
  SukoonVista: {
    id: "36",
    element: SukoonVista,
    path: "/projects/sukoon-vista",
  },
  HMRWaterfront: {
    id: "37",
    element: HMRWaterfrontPage,
    path: "/projects/hmr-waterfront",
  },
  Citadel7: {
    id: "38",
    element: Citadel7,
    path: "/projects/citadel7",
  },
  NotFound404: { id: "39", element: NotFound404, path: "/*" },
};

/* =========================================================
   TOP BAR — uses auth context
   ========================================================= */
function TopBar() {
  const { currentUser } = useAuth();
  const [hasAgency, setHasAgency] = useState(false);
  const [agencyData, setAgencyData] = useState(null);
  const [agencyId, setAgencyId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUserAgency = async () => {
      if (currentUser) {
        try {
          const agentsRef = collection(db, "Featured-Agents");
          const q = query(agentsRef, where("userId", "==", currentUser.uid));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const agencyDoc = querySnapshot.docs[0];
            setHasAgency(true);
            setAgencyData(agencyDoc.data());
            setAgencyId(agencyDoc.id);
          } else {
            setHasAgency(false);
            setAgencyData(null);
            setAgencyId(null);
          }
        } catch (error) {
          console.error("Error checking agency:", error);
          setHasAgency(false);
          setAgencyData(null);
          setAgencyId(null);
        }
      } else {
        setHasAgency(false);
        setAgencyData(null);
        setAgencyId(null);
      }
      setLoading(false);
    };

    checkUserAgency();
  }, [currentUser]);

  return (
    <div className="bg-gradient-to-r from-emerald-900 via-green-800 to-emerald-900 py-3 shadow-lg border-b border-amber-400/30">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Left side - Partner message */}
          <div className="flex items-center space-x-3">
            <div className="hidden sm:flex items-center space-x-2">
              <svg
                className="w-5 h-5 text-amber-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                />
              </svg>
              <span className="text-amber-400 font-semibold">
                Agency Portal:
              </span>
            </div>
            <span className="text-white text-base md:text-lg font-medium">
              {hasAgency && agencyData ? (
                <>
                  <span className="hidden sm:inline">Welcome back, </span>
                  <span className="font-semibold text-amber-300">
                    {agencyData.sellerName || "Agency Partner"}
                  </span>
                  <span className="hidden sm:inline">! </span>
                </>
              ) : (
                "Partner With Us"
              )}
            </span>
            {!hasAgency && (
              <div className="hidden sm:flex items-center space-x-1 text-amber-400/80 text-sm">
                <span>|</span>
                <span>Create Your Agency Profile</span>
              </div>
            )}
          </div>

          {/* Right side - CTA Button */}
          <div>
            {!loading &&
              (hasAgency && agencyData && agencyId ? (
                <a
                  href={`/agent-profile/${agencyId}`}
                  className="group relative inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-emerald-900 font-semibold px-5 md:px-7 py-1.5 md:py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-xl text-sm md:text-base overflow-hidden"
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 md:w-5 md:h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                    Go to Your Agency Profile
                    <svg
                      className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-amber-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </a>
              ) : (
                <a
                  href="/register-agency"
                  className="group relative inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-600 text-emerald-900 font-semibold px-5 md:px-7 py-1.5 md:py-2 rounded-full transition-all duration-300 transform hover:scale-105 shadow-md hover:shadow-xl text-sm md:text-base overflow-hidden"
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <svg
                      className="w-4 h-4 md:w-5 md:h-5 animate-pulse"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                    Get Started →
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-amber-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </a>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   APP
   ========================================================= */
function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [timeSpent, setTimeSpent] = useState(0);
  const [popupShown, setPopupShown] = useState(false);
  const [startTime, setStartTime] = useState(Date.now());
  const [isUserActive, setIsUserActive] = useState(true);

  // Track time spent on the site
  useEffect(() => {
    let interval;
    let inactivityTimer;

    const checkTimeSpent = () => {
      if (isUserActive) {
        const currentTime = Date.now();
        const elapsedSeconds = Math.floor((currentTime - startTime) / 1000);
        setTimeSpent(elapsedSeconds);

        if (!popupShown && elapsedSeconds >= 45 && elapsedSeconds <= 60) {
          setShowPopup(true);
          setPopupShown(true);
        }
      }
    };

    interval = setInterval(checkTimeSpent, 1000);

    return () => {
      clearInterval(interval);
      if (inactivityTimer) clearTimeout(inactivityTimer);
    };
  }, [popupShown, startTime, isUserActive]);

  // Track user activity
  useEffect(() => {
    let inactivityTimer;
    let lastActivityTime = Date.now();

    const resetInactivityTimer = () => {
      lastActivityTime = Date.now();
      if (!isUserActive) {
        setIsUserActive(true);
        const inactiveDuration = Date.now() - lastActivityTime;
        setStartTime((prev) => prev + inactiveDuration);
      }

      if (inactivityTimer) clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        setIsUserActive(false);
      }, 30000);
    };

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];
    events.forEach((event) => {
      document.addEventListener(event, resetInactivityTimer);
    });

    resetInactivityTimer();

    return () => {
      if (inactivityTimer) clearTimeout(inactivityTimer);
      events.forEach((event) => {
        document.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [isUserActive]);

  // Reset timer when page becomes visible again
  useEffect(() => {
    let hiddenStartTime = 0;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        hiddenStartTime = Date.now();
      } else {
        if (hiddenStartTime) {
          const hiddenDuration = Date.now() - hiddenStartTime;
          setStartTime((prev) => prev + hiddenDuration);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  const shouldShowPopup = useCallback(() => {
    const excludedPaths = [
      "/sign-in",
      "/sign-up",
      "/forgot-password",
      "/profile",
      "/register-agency",
    ];
    const currentPath = window.location.pathname;
    return !excludedPaths.some((path) => currentPath.includes(path));
  }, []);

  return (
    <HelmetProvider>
      <LoadingProvider>
        {/* =========================================================
            GLOBAL DEFAULT SEO — pages override via their own <Helmet>
            ========================================================= */}
        <Helmet>
          <meta charSet="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta
            name="description"
            content="EstateGhar - Pakistan's leading real estate platform. Buy, sell, and rent properties including houses, plots, commercial spaces, luxury villas, and apartments nationwide."
          />
          <meta
            name="keywords"
            content="real estate pakistan, projects in islamabad, luxury projects in islamabad, faisal hills, bahria town, gulberg greens, gulberg, villas in islamabad, b17 islamabad, property for sale in pakistan, buy property pakistan, sell property pakistan, rent property pakistan, houses for sale in pakistan, plots for sale pakistan, commercial property pakistan, luxury villas pakistan, apartments for rent pakistan, real estate agents pakistan, property deals pakistan, EstateGhar real estate, property investment pakistan, land for sale pakistan, real estate islamabad, real estate lahore, real estate karachi, real estate peshawar, real estate swat, property buying guide pakistan"
          />
          <meta name="author" content={SITE_NAME} />
          <meta name="robots" content="index, follow" />
          <title>EstateGhar | Buy, Sell & Rent Properties in Pakistan</title>

          <link rel="canonical" href={`${SITE_URL}/`} />

          <meta property="og:type" content="website" />
          <meta property="og:site_name" content={SITE_NAME} />
          <meta property="og:url" content={`${SITE_URL}/`} />
          <meta
            property="og:title"
            content="EstateGhar | Buy, Sell & Rent Properties in Pakistan"
          />
          <meta
            property="og:description"
            content="EstateGhar - Your trusted platform for real estate in Pakistan. Explore houses, plots, commercial spaces, and luxury villas."
          />
          <meta property="og:image" content={`${SITE_URL}/og-image.jpg`} />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:url" content={`${SITE_URL}/`} />
          <meta
            name="twitter:title"
            content="EstateGhar | Buy, Sell & Rent Properties in Pakistan"
          />
          <meta
            name="twitter:description"
            content="EstateGhar - Your trusted platform for real estate in Pakistan."
          />
          <meta name="twitter:image" content={`${SITE_URL}/twitter-image.jpg`} />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              name: SITE_NAME,
              url: SITE_URL,
              logo: `${SITE_URL}/logo.png`,
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: SITE_NAME,
              url: SITE_URL,
              potentialAction: {
                "@type": "SearchAction",
                target: `${SITE_URL}/search?q={search_term_string}`,
                "query-input": "required name=search_term_string",
              },
            })}
          </script>
        </Helmet>

        <AuthProvider>
          <UserProvider>
            <Router>
              <ScrollToTop />
              <TopBar />
              <Header />
              <Routes>
                {/* =========================================================
                    ✅ SEO-friendly listings URLs (main money pages)
                    ========================================================= */}
                <Route path="/properties-for-sale" element={<ListingsForSale />} />
                <Route path="/properties-for-rent" element={<ListingsForRent />} />
                <Route
                  path="/properties-for-sale-in-:citySlug"
                  element={<ListingsForSale />}
                />
                <Route
                  path="/properties-for-rent-in-:citySlug"
                  element={<ListingsForRent />}
                />

                {/* =========================================================
                    🔁 Legacy redirects
                    ========================================================= */}
                <Route
                  path="/listings/sale"
                  element={<Navigate to="/properties-for-sale" replace />}
                />
                <Route
                  path="/listings/rent"
                  element={<Navigate to="/properties-for-rent" replace />}
                />

                {/* =========================================================
                    EXISTING ROUTES
                    ========================================================= */}
                {Object.entries(ROUTES).map((route) => {
                  const [key, value] = route;
                  const TopLevelComponent = value.element;
                  return (
                    <Route
                      key={key}
                      path={value.path}
                      element={<TopLevelComponent />}
                    />
                  );
                })}

                <Route
                  path="/profile"
                  element={<PrivateRoute route="/sign-in" />}
                >
                  <Route path="/profile" element={<Profile />} />
                </Route>
                <Route
                  path="/contact/:carOwnerId"
                  element={<PrivateRoute route="/sign-in" />}
                />
              </Routes>
              <Footer />

              <RecommendationPopup
                isOpen={showPopup && shouldShowPopup()}
                onClose={handleClosePopup}
                timeSpent={timeSpent}
              />
            </Router>
          </UserProvider>
        </AuthProvider>

        {/* WhatsApp Icon - Hidden on mobile */}
        <a
          href="https://wa.me/923487172565?text=Hello%20EstateGhar%20Team,%20I%20am%20interested%20in%20buying/selling%20a%20property.%20Could%20you%20please%20assist%20me?"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex fixed bottom-5 right-5 z-50 bg-green-500 hover:bg-green-600 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
          title="Chat with us on WhatsApp"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            viewBox="0 0 24 24"
            width="28"
            height="28"
          >
            <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.945C.157 5.3 5.52 0 12.057 0c3.187 0 6.167 1.24 8.413 3.488a11.823 11.823 0 0 1 3.488 8.41c-.003 6.538-5.367 11.902-11.903 11.902a11.9 11.9 0 0 1-5.938-1.59L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.402 1.593 5.448 0 9.885-4.433 9.888-9.884.002-5.462-4.418-9.887-9.883-9.89-5.45 0-9.884 4.435-9.884 9.89 0 2.126.615 3.72 1.657 5.405l-.999 3.648 3.819-.762zM17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.472-.148-.67.15-.197.297-.768.966-.941 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.52-.075-.148-.669-1.612-.916-2.21-.242-.579-.487-.5-.67-.51-.173-.007-.372-.009-.571-.009-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
          </svg>
        </a>
      </LoadingProvider>
    </HelmetProvider>
  );
}

export default App;